import { useEffect, useState } from 'react';

import styles from './FlatAreaFilter.module.css';

type FlatAreaFilterProps = {
    onChange: (key: 'areaFrom' | 'areaTo', value: number | null) => void;
    reset: boolean;
};

const FlatAreaFilter: React.FC<FlatAreaFilterProps> = ({ onChange, reset }): JSX.Element => {
    const [areaRange, setAreaRange] = useState<{ from: number | null; to: number | null }>({ from: null, to: null });

    useEffect(() => {
        if (reset) {
            setAreaRange({ from: null, to: null });
            onChange('areaFrom', null);
            onChange('areaTo', null);
        }
    }, [reset]);

    /**
     * Updates the area range based on the input.
     * Triggers an onChange callback to update the area filter in Context.
     * @param {'from' | 'to'} key - The key indicating which part of the range to update.
     * @param {number | null} value - The new value for the specified range key.
     * @returns {void}
    */
    const handleInputChange = (key: 'from' | 'to', value: number | null): void => {
        setAreaRange((prevRange) => ({
            ...prevRange,
            [key]: value,
        }));

        if (key === 'from') onChange('areaFrom', value);
        else onChange('areaTo', value);
    };

    return (
        <div className={styles.wrapper}>
            <span className={styles.label}>Powierzchnia</span>
            <div className={styles.inputs}>
                <input
                    type="number"
                    placeholder="od"
                    min={1}
                    max={250}
                    value={areaRange.from ?? ''}
                    onChange={(e) => handleInputChange('from', e.target.value ? Number(e.target.value) : null)}
                />
                <input
                    type="number"
                    placeholder="do"
                    min={1}
                    max={250}
                    value={areaRange.to ?? ''}
                    onChange={(e) => handleInputChange('to', e.target.value ? Number(e.target.value) : null)}
                />
            </div>
        </div>
    );
};

export default FlatAreaFilter;